import {
  MenuItems,
  NextLabel,
  SelectMenu,
  SelectMenuContent,
  SelectMenuItem,
  SelectMenuProvider,
  SelectMenuTriggerType,
  TextInput,
} from '@cint/wonderment';
import { useController, useFormContext } from 'react-hook-form';

import { useFetchData } from '@/api/apiHooks';
import { TextInputField } from '@/components/wonderment';
import { TrackingTemplatesResponse } from '@/utils/types';
import { URLS } from '@/utils/urls';

export const NetworkSelector = () => {
  const { control } = useFormContext();
  const {
    field: { value: trackingTemplateId, onChange: setTrackingTemplateId },
  } = useController({ control, name: 'tracking_template_id' });

  const { data: trackingTemplateData } =
    useFetchData<TrackingTemplatesResponse>({
      url: URLS.getTrackingTemplates(),
    });

  const trackingTemplateOptions = (trackingTemplateData?.data ?? [])
    .filter(({ id, name }) => !!id && !!name)
    .map(({ id, name, configuration }) => ({
      label: name as string,
      value: id as string,
      configuration,
    }));

  const selectedTemplate = trackingTemplateOptions.find(
    (option) => option.value === trackingTemplateId
  );

  const networkLabel = selectedTemplate?.label ?? 'Select a network';

  return (
    <div className="flex flex-col gap-6">
      <SelectMenuProvider
        isMultiSelect={false}
        onSelectedChange={([value]) => setTrackingTemplateId(value)}
        selectedItems={trackingTemplateId ? [trackingTemplateId] : []}
      >
        <SelectMenu
          triggerProps={{
            type: SelectMenuTriggerType.SelectButton,
            props: { label: networkLabel },
          }}
        >
          <SelectMenuContent>
            <MenuItems>
              {trackingTemplateOptions.map((option) => (
                <SelectMenuItem
                  key={option.value}
                  label={option.label}
                  value={option.value}
                />
              ))}
            </MenuItems>
          </SelectMenuContent>
        </SelectMenu>
      </SelectMenuProvider>

      {selectedTemplate && (
        <>
          <div className="flex gap-6">
            <div className="flex-1">
              <TextInputField
                name="advertiser_id"
                label="Advertiser ID"
                placeholder="Type Advertiser ID"
                isRequired={false}
              />
            </div>
            <div className="flex-1">
              <TextInputField
                name="commission_group"
                label="Commission group"
                placeholder="Type Commission group"
                isRequired={false}
              />
            </div>
          </div>
          {selectedTemplate.configuration && (
            <div>
              <NextLabel label="Configured URL" size="sm" />
              <TextInput
                value={selectedTemplate.configuration}
                isReadOnly
                inputControlProps={{ hasCopyButton: true }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
